<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputCountry" });
import { t } from "svelte-i18n";
export let countryCode;
</script>

{#if countryCode !== undefined}

    <img
        src = { `https://cdn.smatch.com/assets/flags/${ countryCode }.svg` }
        alt = { $t(`global.country.${ countryCode }`) }
    />

    { $t(`global.country.${ countryCode }`) }

{/if}

<style>
    img {
        display: inline-block;
        height: 10px;
        vertical-align: baseline;
        margin-right: 2px;
    }</style>